import HomeLogic from './v2/Home/Home.logic'

export default HomeLogic
